//CONFIG
export const UPDATE_AUTH_URL = "updateAuthUrl";
export const UPDATE_ADMIN_API_URL = "updateAdminApiUrl";
export const UPDATE_LOTTERY_API_URL = "updateLotteryApiUrl";

//LOADER
export const SET_LOADER = "setLoader";
